import * as React from 'react';
import { Flex } from '../Box';
import { TextOrNode } from '../Text';
import { Spinner } from '../Spinner';
export var Loading = function Loading(_ref) {
  var spinnerSize = _ref.spinnerSize,
      message = _ref.message;
  return React.createElement(Flex, {
    lss: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      m: 'auto'
    }
  }, React.createElement(Spinner, {
    size: spinnerSize,
    lss: {
      mb: 'sm'
    }
  }), React.createElement(TextOrNode, null, message));
};
Loading.defaultProps = {
  spinnerSize: 'lg'
};